export const PROD_SONY_SCENARIO_ID = '9crbw4zgit';
const DEV_SONY_SCENARIO_ID = 'ed988qf9c6';
const INTERNAL_SONY_SCENARIO_ID = 'ygoyfo9joa';
const TEST_SONY_SCENARIO_ID = 'vmucmrbycs';
const SONY_EUROPE_EMAIL_COPILOT_SCENARIO_ID = 'gigau00y4c';
export const SONY_SCENARIO_ID_LIST = [
  PROD_SONY_SCENARIO_ID,
  DEV_SONY_SCENARIO_ID,
  INTERNAL_SONY_SCENARIO_ID,
  TEST_SONY_SCENARIO_ID,
  SONY_EUROPE_EMAIL_COPILOT_SCENARIO_ID,
];
export const TRIAGE_DATA_EXPORT_ALLOWED_SCENARIO_IDS = [
  PROD_SONY_SCENARIO_ID,
  'ahjsktqy14', // SONY_TRIAGE_DEMO_SCENARIO_ID
  'nve1qd_dev_admin', // local Krzysztofs scenario id
];
export const QUICKCHAT_SUPPORT_BOT_SCENARIO_ID = 'qj6hw2tua6';
export const DEV_QUICKCHAT_SUPPORT_BOT_SCENARIO_ID = 'uof2azxlgp_dev';

// Custom-tier scenarios that still receive activity-summary emails. Mirror of ALWAYS_INCLUDED_SCENARIO_IDS in quickchat/activity_summary/consts.py — keep in sync.
export const EMAIL_SUMMARY_ALWAYS_INCLUDED_SCENARIO_IDS = [
  QUICKCHAT_SUPPORT_BOT_SCENARIO_ID,
  PROD_SONY_SCENARIO_ID,
  SONY_EUROPE_EMAIL_COPILOT_SCENARIO_ID,
];
